exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-block[data-v-145bf0cd]{width:350px}.sign-block .input-with-button[data-v-145bf0cd]{width:calc(100% - 44px)}.sign-block .input-button[data-v-145bf0cd]{padding-left:0;padding-right:0;width:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-145bf0cd","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/DocumentSigning.vue
// module id = qIm/
// module chunks = 1